<template lang="pug">

  .full-width-wrapper
    div
      //-childコンポーネントのrouter-view
      #child-area
        router-view(ref="myPageChild")
      #headline 
        .m-1 <b>{{$parent.rockyName}}</b> 
        .ml-1 のルート一覧
    div
      table.table
        thead
          tr
            th(v-for="field in fields") {{field.label}}
        tbody
          tr(v-for="route in this.routeList")
            td
              router-link(:to="{ name: 'rockyInfo_:rockyId_:rockId', params: { rockyId: $route.params.rockyId, rockId: route.rockId, rockName: route.rockName, routeId: route.routeId, rockyMasterData: $parent.rockyMasterData }}") {{cnvRouteName(route.routeName)}}
            td {{route.gradeName}}
            td
              router-link(:to="{ name: 'rockyInfo_:rockyId_:rockId', params: { rockyId: $route.params.rockyId, rockId: route.rockId, rockName: route.rockName, rockyMasterData: $parent.rockyMasterData }}") {{route.rockName}}
            td
              router-link(:to="{ name: 'record_edit', query: { rockyId:rockyId, rockId:route.rockId, routeId:route.routeId, ref:'routeId'}}")
                i.fas.fa-edit
</template>

<script>
export default {
// データオブジェクト
  data() {
    return {
      //親コンポーネントの値を利用する
      routeList: this.$parent.routeList,
      rockyId: this.$parent.rockyId,
      isLogin: false,
      //rocky-InfoAPIの戻り値を保持
      rockyMasterData: null,
      fields: [
        {
          key: 'routeName',
          label: 'ルート名',
          sortable: true,
          thStyle: { backgroundColor: '#171D32',color: 'white'}
        },
        {
          key: 'gradeName',
          label: 'グレード',
          sortable: true,
          thStyle: { backgroundColor: '#171D32',color: 'white'}
        },
        {
          key: 'rockName',
          label: '岩',
          sortable: true,
          thStyle: { backgroundColor: '#171D32',color: 'white'}
        },
        {
          key: 'record',
          label: '記録',
          sortable: false,
          thStyle: { backgroundColor: '#171D32',color: 'white'}
        },
      ],
    }
  },
  created(){
    //直接アクセス等で親画面のデータが空の場合、親画面に遷移する
    if(this.$parent.rockyMasterData == null){
      this.$router.push({ 
        name: 'rockyInfo_:rockyId', 
        params: {
          rockyId: this.$route.params.rockyId,
        }
      })
    }
  },
  mounted(){
    //岩アイコンを表示する(Mapコンポーネント内のメソッド実行)
    this.$parent.$refs.map.showRockMarker(true)
  },
  // メソッド
  methods: {
    //---------------------------------------
    // ルート名が存在しないとき、ルート名を書き換える
    //---------------------------------------
    cnvRouteName(routeName){
      return routeName == null || routeName == '' ? '（ルート名無し）' : routeName
    },
  }
}
</script>

<style lang="stylus" scoped>

#headline
  height 40px
  font-size 1.1rem
  background #004170
  color #FFF
  padding-left 0.7rem
  display flex
  align-items center

.spinner
  height 200px
  width 100%

#route-list-container
  margin 0 0
  margin-right -15px
  margin-left -15px
  min-height 35vh

  #overlay-wrapper
    position absolute
    top 50vh
    left 0
    width 100%
    height 60vh
    text-align center
    background linear-gradient(to bottom, rgba(255,255,255,0), #fff 15%);
    z-index 5
    #overlay
      #info-area
        padding 1.5rem 0
        span
          font-weight 600
          color #df5f6a
      #button-area
        button
          width 100%
          margin-bottom 2rem

#rock-paging
  display flex
  justify-content space-between
  align-items center
  height 30px
  padding 10px
  font-weight 600
  font-size 1rem
  margin 2rem 0 1.5rem 0
  .pager
    cursor pointer
    color #f9f9fa
    background #dee1e3
    border-radius 30px
    padding 7px 1rem
  .isPagerActive
    color #eceeef
    background #004170
    &:active
      background #015ea1

#rock-name
  display flex
  justify-content space-between
  font-weight 600
  margin 0 1rem
  #name
    font-size 1.2rem
  #count
    padding-top 8px
    font-size 0.8rem
    color #606e79

#rock-detail
  .row
    margin-left 0
    margin-right 0

#route-info
  background #e2eff9
  color #2d8fd5
  margin 5px 0
  padding 5px
  border-radius 3px

#all-route-list
  border-top 5px solid #cfd3d7
  border-bottom 5px solid #cfd3d7
  width 100%
  overflow-y scroll
  white-space nowrap
  &::-webkit-scrollbar
    width 7px
    height 7px
  &::-webkit-scrollbar-track
    border-radius 5px
  &::-webkit-scrollbar-thumb
    border-radius 5px
    background #adb4b9
  &::-webkit-scrollbar-track
    border-radius 5px
  margin-bottom 1rem
  #list-innner
    .list-row
      min-height 38px
      width 100%
      font-size 0.9rem
      display flex
      justify-content center
      align-items center
      border-bottom solid 1px #dee1e3
      white-space pre-wrap //改行コードを有効にする
      cursor pointer
      // .list-no
      //   width 10%
      //   padding 0 1rem
      .list-route-name
        width 60%
      .list-level
        width 20%
      .inner-box
        width 10%
    .listRowImgNotExists
      background #ebebeb
      color #545759
      cursor auto
    .listRowActive
      background #cce4f5

#list-expansion
  margin-top -1rem
  margin-bottom 1rem
  padding-right 0.5rem
  font-size 0.8rem

#rock-img-default
  display none
//ルート画像
#rock-img
  #svg-header
    width 100%
    height 50px
    background #000
    color #fff
    font-size 1.1rem
    font-weight 600
    padding-left 10px
    display flex
    align-items center
  #rock-img-svg-container
    wicth 100%
    position relative
    #svg-wrapper      
      #srcSvg
        template
          polyline
            stroke red
        .strokeInActive, .strokeActive, .coverPolyline
          cursor pointer
        .strokeInActive
          stroke rgba(255,255,255,0.5)
          stroke-width 4

        .strokeActive
          stroke #0596ff
          stroke-width 5

        .coverPolyline
          z-index 99999

    #route-arrow-box-left
      left 0
    #route-arrow-box-right
      right 0
    #route-arrow-box-left, #route-arrow-box-right
      position absolute
      top 40%
      width 8%
      padding 5px 0px
      display flex
      .arrow
        width 40px
        height 50px
        display flex
        justify-content center
        align-items center
        z-index 100
        i
          color rgba(0,0,0,0)
          font-size 2.2rem
        .fas.fa-caret-left
          padding-right 5px
        .fa-caret-right 
          padding-left 5px

      .isRouteArrowActive
        width 100%
        cursor pointer
        background rgba(255,255,255,0.6)
        &:active
          background rgba(255,255,255,0.8)
        i
          color rgba(0,0,0,0.7)

//カルーセル
.VueCarousel
  height 65px

.VueCarousel-wrapper, .VueCarousel-inner, .VueCarousel-slide
  height 100% !important

.VueCarousel-slide .slider-inner 
  height 60px
  display flex 
  justify-content center
  align-items center
  color #fff

.VueCarousel-slide
  display flex 
  justify-content center
  align-items center
  background #374047
  margin 0 2px
  cursor pointer

.thumbnail-wrapper
  position relative
  opacity 0.7
  transition-duration 0.3s

//選択中の画像のstyle
.currentImg
  background #171d32
  img
    filter brightness(115%)

.col-12,.col-md-6
  padding: 0


#list-button-container
  margin-bottom 2rem
  #draw-route-button-area
    margin 1.5rem

// 大デバイス（デスクトップ, 1170px 以上）
@media (min-width 1170px)
  #rock-name
    padding 0
    font-weight 700
    #name
      font-size 1.5rem
    #count
      font-size 1rem

  #rock-img-default
    display block
    img
      width 100%
      height auto

  .VueCarousel-slide
    border-right 3px solid white
  
  #route-list-container
    #overlay-wrapper
      background linear-gradient(to bottom, rgba(236,238,239,0), #fff 10%);
      top 400px
      #overlay
        #button-area
          button
            width 60%
</style>